// Maneja el token de sesion firmado que el backend emite al iniciar sesion
// (ver SistemaEscolarJaliscomodelo/cMultipagosSesion.php). El token es la unica fuente
// de verdad que el servidor usa para saber quien es el cajero y de que
// plantel es; decodificarlo aqui es solo para decidir que mostrar en
// pantalla, la verificacion real de la firma ocurre en el servidor.

const LLAVE_TOKEN = "cajero_token";
export const LLAVE_VISTA = "cajero_vista";

export function guardarSesion(token) {
  localStorage.setItem(LLAVE_TOKEN, token);
}

export function obtenerToken() {
  return localStorage.getItem(LLAVE_TOKEN);
}

// Decodifica el payload del token sin verificar la firma (eso ya lo hizo el
// servidor al emitirlo). Regresa null si no hay token o esta corrupto.
export function decodificarToken(token) {
  if (!token || token.indexOf(".") === -1) return null;

  try {
    const [payloadB64] = token.split(".");
    const base64 = payloadB64.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
}

export function sesionExpirada() {
  const claims = decodificarToken(obtenerToken());
  if (!claims || !claims.exp) return true;
  return Date.now() / 1000 > claims.exp;
}

export function cerrarSesion() {
  localStorage.clear();
  try {
    sessionStorage.removeItem(LLAVE_VISTA);
  } catch (error) {
    // sin sessionStorage no hay nada que limpiar
  }
}
